import React, { FC, Fragment, useState } from 'react';
import styled from 'styled-components';
import { QuestionnairePermissionMatrix } from '../forms/ProductForm';
import { Checkbox } from '../general/forms/Checkbox';
import { AdditionalItemDivider } from './AdditionalListContentUI';

export interface AdditionalProductResultSetsListContentProps {
  item: QuestionnairePermissionMatrix;
  onChange: (item: QuestionnairePermissionMatrix) => void;
  useSelectAll? : boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`;


const ResultSetsWrapper = styled.div`
 display: flex;
 flex-direction: column;
 width: 100%;
`;

const ResultSetWrapper = styled.div`
 display: flex;
 flex-direction: row;
 width: 100%;
 justify-content: space-between;
 margin: .5rem 0;
`;

const ResultSetLabel = styled.div`
  //
`;

const CheckAllWrapper = styled(ResultSetWrapper)`
  padding-bottom: 1rem;
`;

export const AdditionalProductResultSetsListContent: FC<AdditionalProductResultSetsListContentProps> = (props) => {
  const { item, onChange, useSelectAll} = props;
  const [isAllChecked, setIsAllChecked] = useState<boolean>(false);
  return (
    <Wrapper>
      <HeadWrapper>
        <div>{item.resultSets.length > 0 ? 'Bitte wählen Sie die Lösungsansichten aus, in den das Produkt angezeigt werden soll.' : 'Es wurden keine Lösungsansichten zu diesem Fragebogen gefunden!'}</div>
      </HeadWrapper>
      <ContentWrapper>
        <ResultSetsWrapper>
          { 
            item.resultSets.length > 0 && useSelectAll && (
              <Fragment key={item.id}>
                <CheckAllWrapper>
                <ResultSetLabel><b>Alle {isAllChecked ? "abwählen" : "anwählen"}</b></ResultSetLabel>
                  <Checkbox checked={isAllChecked} id={item.id} onChange={(checked) => {
                    const result = { ...item };
                    if(isAllChecked){
                      result.resultSets.forEach(item => item.checked = false);
                      setIsAllChecked(false);
                    } else{
                      result.resultSets.forEach(item => item.checked = true);
                      setIsAllChecked(true);
                    }
                    onChange(result);
                  }}/>
                </CheckAllWrapper>
                <AdditionalItemDivider/>
              </Fragment>
            )
          }
          {
            item.resultSets.length > 0 && item.resultSets.map((resultSet, index) => {
              return <Fragment key={index}>
                <ResultSetWrapper>
                  <ResultSetLabel>{resultSet.id}</ResultSetLabel>
                  <Checkbox checked={resultSet.checked} id={resultSet.id} onChange={(checked) => {
                    const result = { ...item };
                    result.resultSets[index].checked = checked;
                    setIsAllChecked(result.resultSets.every(item=>item.checked));
                    onChange(result);
                  }}/>
                </ResultSetWrapper>
                <AdditionalItemDivider/>
              </Fragment>;
            })
          }
        </ResultSetsWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};
